import { render } from "./rtChDataChart.vue?vue&type=template&id=3bc5bf86&scoped=true"
import script from "./rtChDataChart.vue?vue&type=script&lang=js"
export * from "./rtChDataChart.vue?vue&type=script&lang=js"

import "./rtChDataChart.vue?vue&type=style&index=0&id=3bc5bf86&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc5bf86"]])

export default __exports__